import type { FC, PropsWithChildren } from 'react'

import { TrButton } from '@skytech/ui/Table/TrButton'

import { useIsAdmin } from '@/hooks/access'

export const ConditionalTrButton: FC<
  PropsWithChildren<{
    date: string
    isPaymentActive: boolean
    isEcomDownPayment: boolean
    onSelectSalaryDeduction: (id: string) => void
  }>
> = ({ isPaymentActive, isEcomDownPayment, date, children, onSelectSalaryDeduction }) => {
  const isAdmin = useIsAdmin()
  const isRowClickable = isEcomDownPayment && isAdmin && isPaymentActive

  if (isRowClickable) {
    return <TrButton onClick={() => onSelectSalaryDeduction(date)}>{children}</TrButton>
  }

  return <tr>{children}</tr>
}
